package org.zq.linkgame.ui.theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable

private val LinkGameColorScheme = lightColorScheme(
    primary = DeepBlue,
    onPrimary = LightBlue,
    primaryContainer = LightBlue,
    onPrimaryContainer = DeepBlue,
    secondary = OrangeRed,
    onSecondary = LightYellow,
    secondaryContainer = LightOrangeRed,
    onSecondaryContainer = OrangeRedDark,
    tertiary = DeepGreen,
    onTertiary = LightGreen,
    tertiaryContainer = LightGreen,
    onTertiaryContainer = DeepGreen,
    background = LightBlue,
    onBackground = DeepBlue,
    surface = LightBlue,
    onSurface = DarkGray,
    surfaceVariant = VeryLightGray,
    onSurfaceVariant = DarkGray,
    outline = LightGray,
    outlineVariant = CellBorder
)

@Composable
fun LinkGameTheme(
    content: @Composable () -> Unit
) {
    // 使用思源黑体自定义字体
    val typography = linkGameTypography()
    
    MaterialTheme(
        colorScheme = LinkGameColorScheme,
        typography = typography,
        content = content
    )
}
